import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import cookie from 'js-cookie';
import { errorMessageNotification, isMobile } from "../../../../helpers";
import { Spin, Form, Row, Col, Button, Avatar, Upload, Input, notification as Notification, Modal, AutoComplete } from "antd";

const { Option } = AutoComplete;

let searchTimeout = null;

class Profile extends Component {

    constructor(props) {
        super(props);

        this.endpoint = { keyOne: "account" };
        this.state = {
            form: {},
            loadings: {
                submit: false,
                data: false,
                proxyuser: false,
                proxyusersubmit: false,
                search: false
            },
            isShowModal: false,
            values: {
                proxyUsers: []
            }
        };
        this.proxyUserFormRef = React.createRef();

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint
        })).then(response => {
            loadings.data = false;
            this.setState({
                form: response, loadings
            });
        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    fetch = (values) => {

        let { loadings } = this.state;

        var param = {};
        var method = "updateData";
        loadings.submit = true;
        this.setState({ loadings });

        param = values;

        this.props
            .dispatch(
                actions.definitions[method]({
                    ...this.endpoint,
                    data: param,
                })
            )
            .then((resp) => {
                loadings.submit = false;
                this.setState({
                    loadings,
                });


                Notification.success({
                    message: i18n.t("successSave", {
                        lng: this.props.currentLanguage,
                        type: i18n.t("profile", {
                            lng: this.props.currentLanguage,
                        }),
                    }),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 3,
                });

                this.props.dispatch(actions.auth.getAccount());

            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };

    handlePictureChange = ({ fileList }) => {
        if (fileList && fileList.length > 0) {
            let _this = this;
            _this.setState({ fileList: [] }, () => {
                _this.setState({ fileList });
            });
        }
    };

    handleAvatarSuccess(res) {
        let { form } = this.state;
        form.picturePath = res.picturePath;
        this.props.dispatch(actions.auth.getAccount());
        this.setState({
            uploadButtonLoading: false,
            form,
            fileList: [
                {
                    uid: "-1",
                    name: res.picturePath,
                    status: "done",
                    url: res.picturePath || ""
                }
            ]
        });
    }

    beforeAvatarUpload(file) {
        let hasError = false;
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJPG) {
            Notification.error({
                message: "Error",
                description: "Picture must be JPG or PNG format"
            });
            hasError = true;
        }
        if (!hasError) {
            this.setState({
                uploadButtonLoading: true
            });
        }
        return !hasError;
    }

    handleAvatarError(err) {
        if (err) {
            let error = JSON.parse(
                err
                    .toString()
                    .split(err.status)[1]
                    .substr(1)
            );
            Notification.error({
                message: "Error",
                description:
                    error.errors && error.errors[0]
                        ? error.errors[0].error
                        : "Unknown Error Occured"
            });
        }
        this.setState({
            uploadButtonLoading: false
        });
    }


    showModal = () => {
        this.setState({ isShowModal: !this.state.isShowModal })
    }

    searchProxyUser = (query) => {

        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {

            let { loadings } = this.state;
            loadings.search = true;
            this.setState({ loadings })

            let endpoint = { keyOne: `customer/proxyusers?q=${query}` };
            this.props
                .dispatch(
                    actions.definitions.getDatas({
                        ...endpoint,
                    })
                )
                .then((response) => {
                    let { values } = this.state;
                    values.proxyUsers = response;
                    loadings.search = false;
                    this.setState({ values, loadings });
                });
        }, 500);
    };

    validateAndSubmitProxyUser = () => {
        this.proxyUserFormRef.current.validateFields().then(values => {
            this.fetchProxyUserLogin(values);
        }, error => {
        });
    }

    fetchProxyUserLogin = (values) => {


        let { loadings } = this.state;
        loadings.proxyusersubmit = true;

        this.setState({ loadings })

        var param = {
            username: values.query
        }

        this.props.dispatch(actions.auth.loginProxyUser(param))
            .then(() => {

                loadings.proxyusersubmit = false;
                this.setState({ loadings })

                window.location.pathname = "/app/trips"
            })
            .catch(error => {

                loadings.proxyusersubmit = false;
                this.setState({ loadings })

                let responseErrorMessage = JSON.parse(JSON.stringify(error)).response.data.error_description;

                Notification.error({
                    message: responseErrorMessage,
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 5,
                });
            })
    }


    render() {

        let { form, loadings, isShowModal, values } = this.state;

        const changeButton = (
            <Button
                loading={this.state.uploadButtonLoading}
                type="link"
                className="change-picture-button"
                style={{ marginTop: 60 }}
            >
                <i className="fa fa-camera" aria-hidden="true"></i>
            </Button>
        );

        return (

            <div className="form-container profile">

                {
                    !loadings.data &&
                    <div className='heading'>{`Merhaba, `} <strong> {`${form.name} ${form.lastname}`}</strong></div>
                }

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <Form layout="vertical" className='form-box'
                        onFinish={this.fetch}>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='picture-box'>

                                {
                                    form.picturePath ?

                                        <Avatar
                                            src={form.picturePath}
                                            size={150}
                                        >
                                        </Avatar>
                                        :

                                        <Avatar
                                            src={"/assets/img/logo/defaultAvatar.png"}
                                            size={150}
                                        >
                                        </Avatar>

                                }

                                <Upload
                                    fileList={null}
                                    action={`${process.env.REACT_APP_API_URL}/account/changepicture`}
                                    // onPreview={() => this.deletePicture()}
                                    onChange={fileList => this.handlePictureChange(fileList)}
                                    // onRemove={() => this.setState({ deleteModalVisible: true, })}
                                    onSuccess={(res, file) => this.handleAvatarSuccess(res)}
                                    beforeUpload={file => this.beforeAvatarUpload(file)}
                                    onError={(err, file, fileList) =>
                                        this.handleAvatarError(err)
                                    }
                                    headers={{
                                        Authorization: `bearer ${cookie.get("access_token")}`
                                    }}
                                >
                                    {form.picturePath && changeButton}
                                </Upload>

                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("name", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.name ? form.name : null}
                                >
                                    <Input
                                        placeholder={i18n.t("name", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("lastname", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="lastname"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.lastname ? form.lastname : null}

                                >
                                    <Input
                                        placeholder={i18n.t("lastname", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("email", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="email"
                                    tooltip={`${i18n.t("emailCannotChange", {
                                        lng: this.props.currentLanguage,
                                    })}`}

                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.email ? form.email : null}

                                >
                                    <Input
                                        placeholder={i18n.t("email", {
                                            lng: this.props.currentLanguage,
                                        })}
                                        disabled={true}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Form.Item
                                    label={`${i18n.t("phoneNumber", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="phoneNumber"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.phoneNumber ? form.phoneNumber : null}

                                >
                                    <Input
                                        placeholder={i18n.t("phoneNumber", {
                                            lng: this.props.currentLanguage,
                                        })}
                                        disabled={true}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item className="form-item-submit">
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        className="ant-btn width-100"
                                        style={{ height: 40 }}
                                        loading={this.state.loadings.submit}
                                    >
                                        Değişiklikleri Kaydet
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                }

                {
                    !loadings.data &&
                    <Form layout="vertical" className='form-box' onFinish={this.fetchLogin}>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item className="form-item-submit">
                                    <Button
                                        htmlType="submit"
                                        type="default"
                                        className="ant-btn width-100"
                                        style={{ height: 40, marginTop: 10 }}
                                        loading={loadings.proxyuser}
                                        onClick={() => this.showModal()}
                                    >
                                        Kullanıcı Değiştir
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                }
                <Modal
                    title="Kullanıcı Değiştir"
                    open={isShowModal}
                    onCancel={this.showModal}
                    onOk={this.validateAndSubmitProxyUser}
                    confirmLoading={loadings.proxyusersubmit}
                    className='ant-modal-proxy-user'
                    centered
                    okText="Bağlan"
                >
                    <Form layout="vertical" className='form-box' ref={this.proxyUserFormRef} >
                        <Form.Item
                            name="query"
                            rules={[
                                {
                                    required: true,
                                    message: `${i18n.t("fieldIsRequired", {
                                        lng: this.props.currentLanguage,
                                    })}`,
                                },
                            ]}
                        >
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                // onSelect={this.onSelectIntegrationCodeQuery}
                                onSearch={this.searchProxyUser}
                                loading={loadings.search}
                                placeholder={`${i18n.t("Üye kullanıcılarda ara...", {
                                    lng: this.props.currentLanguage,
                                })}`}
                            >
                                {values.proxyUsers.map((user) => (
                                    <Option key={user.email} value={user.email}>
                                        <strong>{user.name} {user.lastname}</strong> <br />
                                        <div style={{ fontSize: 12 }}>{user.email}</div>
                                    </Option>
                                ))}
                            </AutoComplete>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Profile);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account/Profile.js